module.exports = __webpack_public_path__ + "be0ecca2b352ef747e7e1f9d73964015.woff";